import {NgModule} from '@angular/core';
import {TabsModule} from "primeng/tabs";
import {NsConfigPage} from "./page/overview/ns-config/ns-config.page";
import {NsEmailConfigPage} from "./page/overview/ns-email-config/ns-email-config.page";
import {NsSmsConfigPage} from "./page/overview/ns-sms-config/ns-sms-config.page";
import {
    NsNotificationTypesForObjectComponent
} from "./component/protected-components/ns-notification-types-for-object/ns-notification-types-for-object.component";
import {NsBlackListPage} from "./page/overview/ns-black-list/ns-black-list.page";
import {NsWhiteListPage} from "./page/overview/ns-white-list/ns-white-list.page";
import {
    NsNotificationCommentWfProcessStepMainActivityComponent
} from "./component/protected-components/wf/ns-notification-comment-wf-process-step-main-activity/ns-notification-comment-wf-process-step-main-activity.component";
import {
    NsNotificationCommentWfProcessStepSideActivityComponent
} from "./component/protected-components/wf/ns-notification-comment-wf-process-step-side-activity/ns-notification-comment-wf-process-step-side-activity.component";
import {NsNotificationObjectPage} from "./page/object/notification-object-page/ns-notification-object.page";
// New OBC root (replaces old protected-components version)
import {
    NsNotificationTypeObjectComponent
} from "./component/object-components/ns-notification-type-object-component/ns-notification-type-object.component";
import {
    NsNotificationTypeBaseComponent
} from "./component/object-components/ns-notification-type-object-component/view/ns-notification-type-base.component";
import {
    NsNotificationTypeFullComponent
} from "./component/object-components/ns-notification-type-object-component/view/ns-notification-type-full/ns-notification-type-full.component";
import {
    NsNotificationTypeSideComponent
} from "./component/object-components/ns-notification-type-object-component/view/ns-notification-type-side/ns-notification-type-side.component";
import {
    NsNotificationTypeChannelSelectorComponent
} from "./component/object-components/ns-notification-type-object-component/shared/ns-notification-type-channel-selector/ns-notification-type-channel-selector.component";
import {
    NsNotificationTypeCreateChannelDialogComponent
} from "./component/object-components/ns-notification-type-object-component/shared/ns-notification-type-create-channel-dialog/ns-notification-type-create-channel-dialog.component";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {BlockUIModule} from "primeng/blockui";
import {
    NsNotificationSendComponent
} from "./component/protected-components/ns-notification-send/ns-notification-send.component";
import {
    NotificationStatisticsComponent
} from "./page/notification-overview-page/components/statisticsComponent/notification-statistics.component";
import {
    NotificationKpiComponent
} from "./page/notification-overview-page/components/kpiComponent/notification-kpi.component";
import {
    NsNotificationObjectComponent
} from "./component/protected-components/notification-object-component/ns-notification-object.component";
import {NsDashboardOverviewComponent} from "./page/dashboard/ns-dashboard-overview/ns-dashboard-overview.component";
// "ePost-Status" KPI tiles of the ns dashboard (user decision 2026-10-01; replaces the removed ns/letter-status page)
import {
    NsEpostStatusKpisComponent
} from "./page/dashboard/components/ns-epost-status-kpis/ns-epost-status-kpis.component";
import {NS_ENTITY_PROVIDER} from "./ns.entity-provider";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {CoreModule} from "../../core/core.module";
import {PMessagesComponent} from "../../core/shared/p-messages/p-messages.component";
import {NS_TEST_PROVIDERS} from "./test/ns-test-definition";
import {NS_WF_ACTIVITY_PROVIDER} from "./ns-wf-activity.provider";
import {
    NsNotificationTypeObjectPage
} from "./page/object/notification-type-object-page/ns-notification-type-object.page";
import {
    NsConfigCheckResultComponent
} from "./component/protected-components/ns-config-check-result/ns-config-check-result.component";
import {NsNotificationTypePocPage} from "./page/ns-notification-type-poc/ns-notification-type-poc.page";
import {NsQuickCreatePocComponent} from "./component/poc/ns-quick-create-poc.component";
import {
    NsPocChannelConfigComponent
} from "./page/ns-notification-type-poc/components/channel-config/ns-poc-channel-config.component";
import {
    NsPocVariableMappingComponent
} from "./page/ns-notification-type-poc/components/variable-mapping/ns-poc-variable-mapping.component";
import {
    NsPocConfigCheckComponent
} from "./page/ns-notification-type-poc/components/config-check/ns-poc-config-check.component";
import {
    NsNotificationTypeHeaderComponent
} from "./component/object-components/ns-notification-type-object-component/shared/ns-notification-type-header/ns-notification-type-header.component";
import {
    NsNotificationTypeWizardPage
} from "./page/ns-notification-type-wizard/ns-notification-type-wizard.page";
import {
    NsNotificationTypeWizardWrapperPage
} from "./page/ns-notification-type-wizard/ns-notification-type-wizard-wrapper.page";
import {
    NsWizardStepBasicsComponent
} from "./page/ns-notification-type-wizard/components/wizard-step-basics/ns-wizard-step-basics.component";
import {
    NsWizardStepChannelsComponent
} from "./page/ns-notification-type-wizard/components/wizard-step-channels/ns-wizard-step-channels.component";
import {
    NsWizardStepFieldsComponent
} from "./page/ns-notification-type-wizard/components/wizard-step-fields/ns-wizard-step-fields.component";
import {
    NsWizardStepReviewComponent
} from "./page/ns-notification-type-wizard/components/wizard-step-review/ns-wizard-step-review.component";
import {
    NsWizardChannelCardComponent
} from "./page/ns-notification-type-wizard/components/wizard-channel-card/ns-wizard-channel-card.component";
import {
    NsWizardChannelTypeSelectorComponent
} from "./page/ns-notification-type-wizard/components/wizard-channel-type-selector/ns-wizard-channel-type-selector.component";
import {
    NsWizardConfigCheckComponent
} from "./page/ns-notification-type-wizard/components/wizard-config-check/ns-wizard-config-check.component";
import {
    NsVariableMappingAssistantComponent
} from "./component/protected-components/ns-variable-mapping-assistant/ns-variable-mapping-assistant.component";
import {
    NsFixAllChannelsDialogComponent
} from "./component/protected-components/ns-fix-all-channels-dialog/ns-fix-all-channels-dialog.component";
import {InputIcon} from "primeng/inputicon";
// POC: 4-step wizard
import {NsPocComponent} from "./component/ns-poc/ns-poc.component";
import {PocStepBasicsComponent} from "./component/ns-poc/components/poc-step-basics/poc-step-basics.component";
import {PocStepChannelsComponent} from "./component/ns-poc/components/poc-step-channels/poc-step-channels.component";
import {PocStepFieldsComponent} from "./component/ns-poc/components/poc-step-fields/poc-step-fields.component";
import {PocStepReviewComponent} from "./component/ns-poc/components/poc-step-review/poc-step-review.component";
// POC: Widget Header
import {NsWidgetHeaderPocComponent} from "./poc/widget-header/ns-widget-header-poc.component";
// TM-1000001984: ePost mail-status jobs sub-view of the ns dashboard
import {
    NsMailStatusJobsComponent
} from "./page/dashboard/components/ns-mail-status-jobs/ns-mail-status-jobs.component";

// Sendungsakte: the ns.NsNotification object component and its four tabs.
// DmModule is imported for <mvs-dm-pdf-viewer> — documents are addressed by ID through the
// authenticated HTTP path, never by URL. It exports the viewer, has no back-dependency on ns, and
// seven feature modules already import it.
import {DmModule} from "../dm/dm.module";
import {
    NsDispatchStateChipComponent
} from "./component/protected-components/ns-dispatch-state-chip/ns-dispatch-state-chip.component";
import {
    NsNotificationDispatchHeaderComponent
} from "./component/protected-components/ns-notification-dispatch-header/ns-notification-dispatch-header.component";
import {
    NsNotificationDeliveryPanelComponent
} from "./component/protected-components/ns-notification-delivery-panel/ns-notification-delivery-panel.component";
import {
    NsNotificationDocumentPanelComponent
} from "./component/protected-components/ns-notification-document-panel/ns-notification-document-panel.component";
import {
    NsNotificationEpostPanelComponent
} from "./component/protected-components/ns-notification-epost-panel/ns-notification-epost-panel.component";
import {
    NsNotificationDiagnosticsPanelComponent
} from "./component/protected-components/ns-notification-diagnostics-panel/ns-notification-diagnostics-panel.component";
// "Versendete Benachrichtigungen" of a business object (e.g. bd.Dunning) — exported for the host OBCs.
import {
    NsObjectSentNotificationsComponent
} from "./component/public-components/ns-object-sent-notifications/ns-object-sent-notifications.component";


@NgModule({
    declarations: [
        NsConfigPage,
        NsEmailConfigPage,
        NsSmsConfigPage,
        NsNotificationTypesForObjectComponent,
        NsBlackListPage,
        NsWhiteListPage,
        NsNotificationCommentWfProcessStepMainActivityComponent,
        NsNotificationCommentWfProcessStepSideActivityComponent,
        NsNotificationObjectPage,
        NsNotificationTypeObjectComponent,
        NsNotificationTypeBaseComponent,
        NsNotificationTypeFullComponent,
        NsNotificationTypeSideComponent,
        NsNotificationTypeChannelSelectorComponent,
        NsNotificationTypeCreateChannelDialogComponent,
        NsNotificationSendComponent,
        NotificationStatisticsComponent,
        NotificationKpiComponent,
        NsNotificationObjectComponent,
        NsDashboardOverviewComponent,
        NsEpostStatusKpisComponent,
        NsNotificationTypeObjectPage,
        NsConfigCheckResultComponent,
        NsNotificationTypePocPage,
        NsPocChannelConfigComponent,
        NsPocVariableMappingComponent,
        NsPocConfigCheckComponent,
        NsNotificationTypeHeaderComponent,
        NsNotificationTypeWizardPage,
        NsWizardStepBasicsComponent,
        NsWizardStepChannelsComponent,
        NsWizardStepFieldsComponent,
        NsWizardStepReviewComponent,
        NsWizardChannelCardComponent,
        NsWizardChannelTypeSelectorComponent,
        NsWizardConfigCheckComponent,
        NsNotificationTypeWizardWrapperPage,
        NsVariableMappingAssistantComponent,
        NsFixAllChannelsDialogComponent,
        NsQuickCreatePocComponent,
        // POC: 4-step wizard
        NsPocComponent,
        PocStepBasicsComponent,
        PocStepChannelsComponent,
        PocStepFieldsComponent,
        PocStepReviewComponent,
        // POC: Widget Header
        NsWidgetHeaderPocComponent,
        NsMailStatusJobsComponent, // TM-1000001984
        // Sendungsakte tabs
        NsDispatchStateChipComponent,
        NsNotificationDispatchHeaderComponent,
        NsNotificationDeliveryPanelComponent,
        NsNotificationDocumentPanelComponent,
        NsNotificationEpostPanelComponent,
        NsNotificationDiagnosticsPanelComponent,
        NsObjectSentNotificationsComponent
    ],


  exports: [
    NsConfigPage,
    NsEmailConfigPage,
    NsSmsConfigPage,
    NsNotificationTypesForObjectComponent,
    NsBlackListPage,
    NsWhiteListPage,
    NsNotificationCommentWfProcessStepMainActivityComponent,
    NsNotificationCommentWfProcessStepSideActivityComponent,
    NsNotificationObjectPage,
    NsNotificationTypeObjectComponent,
    NsNotificationSendComponent,
    NsNotificationObjectComponent,
    NsVariableMappingAssistantComponent,
    NsNotificationTypePocPage,
    NsNotificationTypeWizardWrapperPage,
    NsObjectSentNotificationsComponent,
  ],
    imports: [
        CoreModule,
        ProgressSpinnerModule,
        BlockUIModule,
        PMessagesComponent,
        TabsModule,
        InputIcon,
        DmModule,
    ],
    providers: [NS_ENTITY_PROVIDER, NS_TEST_PROVIDERS, ...NS_WF_ACTIVITY_PROVIDER]
})
export class NsModule implements DynamicModule {

    alias = 'ns';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return NotificationKpiComponent;
    }

    getStatisticsComponent() {
        return NotificationStatisticsComponent;
    }

}



